import * as THREE from "three";

/**
 * The current build renders placeholder primitives, so nothing is loaded over
 * the network yet. Three's loaders all funnel through the default loading
 * manager, so installing the handler here means the first external asset added
 * later cannot take the frame loop down with an unhandled error.
 */
export function installAssetErrorHandling(
  onFailure: (url: string) => void = () => undefined,
): void {
  THREE.DefaultLoadingManager.onError = (url) => {
    console.warn(`[assets] failed to load: ${url}`);
    onFailure(url);
  };
}
